import { useMemo } from "react";
import ProductGridCard from "@/components/feature/ProductGridCard";
import Reveal from "@/components/base/Reveal";
import { useLiveProducts } from "@/lib/siteContent";
import type { Product } from "@/types";

interface RelatedProductsProps {
  current: Product;
}

export default function RelatedProducts({ current }: RelatedProductsProps) {
  const products = useLiveProducts();
  const items = useMemo(() => {
    const sameCategory = products.filter(
      (product) => product.categoryId === current.categoryId && product.id !== current.id,
    );
    const others = products.filter(
      (product) => product.categoryId !== current.categoryId && product.id !== current.id,
    );
    return [...sameCategory, ...others].slice(0, 4);
  }, [current, products]);

  if (items.length === 0) return null;

  return (
    <section className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-2">
          <span className="text-[11px] uppercase tracking-[0.28em] text-accent-700">
            Combina com você
          </span>
          <h2 className="font-heading text-3xl font-medium text-foreground-900 md:text-4xl">
            Quem viu este produto também gostou
          </h2>
        </div>

        <div
          data-product-shop
          className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
        >
          {items.map((product, index) => (
            <Reveal key={product.id} delay={index * 70}>
              <ProductGridCard product={product} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}